import { render, staticRenderFns } from "./orderAssignment.vue?vue&type=template&id=5d8077ad&scoped=true"
import script from "./orderAssignment.vue?vue&type=script&lang=js"
export * from "./orderAssignment.vue?vue&type=script&lang=js"
import style0 from "./orderAssignment.vue?vue&type=style&index=0&id=5d8077ad&prod&scoped=true&lang=scss"
import style1 from "./orderAssignment.vue?vue&type=style&index=1&id=5d8077ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8077ad",
  null
  
)

export default component.exports